import { defineStore } from 'pinia';

export const useSeasonalAnimationStore = defineStore('seasonalAnimation', {
  state: () => ({
    isRunning: false,
    isShowing: false,
    runTimeoutId: null,
    showTimeoutId: null
  }),
  actions: {
    trigger(duration) {
      const ANIMATION_LEAVE_TRANSITION_MS = 1000;
      if (this.isRunning) return false;

      this.isRunning = true;
      this.isShowing = true;

      if (duration) {
        this.runTimeoutId = window.setTimeout(() => {
          this.stopRunning();
        }, duration);

        this.showTimeoutId = window.setTimeout(() => {
          this.stopShowing();
        }, duration - ANIMATION_LEAVE_TRANSITION_MS);
      }

      return true;
    },

    stopRunning() {
      if (this.runTimeoutId) {
        clearTimeout(this.runTimeoutId);
        this.runTimeoutId = null;
      }

      this.isRunning = false;
    },

    stopShowing() {
      if (this.showTimeoutId) {
        clearTimeout(this.showTimeoutId);
        this.showTimeoutId = null;
      }

      this.isShowing = false;
    }
  }
});
